export default __webpack_public_path__ + "static/media/money-bag.699892e8.svg";